module.exports = Promise.all([parcelRequire.load("l6xiM"), parcelRequire.load("8k0g9"), parcelRequire.load("7elAd")]).then(() => parcelRequire('6XVMp'));